<i18n
  src="@/locales/components/views/agro_exporter/quality_control/container/show_inspect/quality_group_details.yml"
  lang="yaml"
></i18n>
<i18n
  src="@/locales/models/quality_sampling_group.yml"
  lang="yaml"
></i18n>
<i18n
  src="@/locales/models/quality_general.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div
          class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
        >
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell px-1 text-center">
                  #
                </th>
                <th
                  scope="col"
                  v-for="quality_attribute in quality_attributes"
                  :key="quality_attribute.id"
                  class="table-header-cell text-center px-1.5"
                >
                  <div class="tooltip">
                    <p>
                      {{
                        quality_attribute?.abbreviation ||
                        quality_attribute?.crop_attribute?.name
                      }}
                    </p>
                    <span
                      v-if="quality_attribute.abbreviation"
                      class="tooltip-text"
                    >
                      {{ quality_attribute?.crop_attribute?.name }}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  class="table-header-cell text-center px-1.5"
                  v-if="show_group_stats"
                >
                  {{ $t("model.quality_sampling_groups.average") }}
                </th>
                <th
                  scope="col"
                  class="table-header-cell text-center px-1.5"
                  v-if="show_group_stats"
                >
                  {{ $t("model.quality_sampling_groups.min_value") }}
                </th>
                <th
                  scope="col"
                  class="table-header-cell text-center px-1.5"
                  v-if="show_group_stats"
                >
                  {{ $t("model.quality_sampling_groups.max_value") }}
                </th>
                <th
                  scope="col"
                  v-for="group_range in group_ranges"
                  :key="group_range.id"
                  class="table-header-cell text-center px-1.5"
                >
                  <div class="tooltip">
                    <p>
                      {{ group_range.label }}
                    </p>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row divide-x"
                v-for="(quality_sampling, index) in quality_samplings"
                :key="quality_sampling.id"
              >
                <td class="table-cell-pos px-1.5 text-center">
                  {{ quality_samplings.length == 1 ? "Valor" : index + 1 }}
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-for="quality_attribute in quality_attributes"
                  :key="quality_attribute.id"
                >
                  <show-sampling-value
                    :quality_attribute="quality_attribute"
                    :sampling_detail="
                      getSamplingDetail(quality_sampling, quality_attribute)
                    "
                  />
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  {{ getSamplingGroupAvg(quality_sampling) }}
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  {{ getSamplingGroupMinValue(quality_sampling) }}
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  {{ getSamplingGroupMaxValue(quality_sampling) }}
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-for="group_range in group_ranges"
                  :key="group_range.id"
                >
                  {{ getGroupRangeValue(quality_sampling, group_range) }}
                </td>
              </tr>
              <tr class="table-row divide-x" v-if="show_total">
                <td class="table-cell-pos px-1 text-center">
                  {{ $t("labels.total") }}
                </td>
                <td
                  v-for="quality_attribute in quality_attributes"
                  :key="quality_attribute.id"
                  class="table-cell-main text-center"
                >
                  <p
                    v-if="
                      quality_samplings?.length > 1 &&
                      showTotalAttribute(quality_attribute)
                    "
                  >
                    {{
                      getGeneral(quality_inspect, quality_attribute)
                        ?.value_float
                    }}
                  </p>
                  <p v-if="quality_group.calculate_percentages">
                    {{
                      getGeneral(quality_inspect, quality_attribute)
                        ?.percent_total_by_group ?? 0
                    }}%
                  </p>
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- average -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- min_value -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- max_value -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-for="group_range in group_ranges"
                  :key="group_range.id"
                ></td>
              </tr>
              <tr class="table-row divide-x">
                <td class="table-cell-pos px-1 text-center">
                  {{ $t("model.quality_general.average") }}
                </td>
                <td
                  v-for="quality_attribute in quality_attributes"
                  :key="quality_attribute.id"
                  class="table-cell-main text-center"
                >
                  <p
                    v-if="
                      showStatsAttribute(quality_attribute) &&
                      quality_samplings?.length > 1
                    "
                  >
                    {{
                      getGeneral(quality_inspect, quality_attribute)?.average
                    }}
                  </p>
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- average -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- min_value -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- max_value -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-for="group_range in group_ranges"
                  :key="group_range.id"
                ></td>
              </tr>
              <tr class="table-row divide-x">
                <td class="table-cell-pos px-1 text-center">
                  {{ $t("model.quality_general.min_value") }}
                </td>
                <td
                  v-for="quality_attribute in quality_attributes"
                  :key="quality_attribute.id"
                  class="table-cell-main text-center"
                >
                  <p
                    v-if="
                      showStatsAttribute(quality_attribute) &&
                      quality_samplings?.length > 1
                    "
                  >
                    {{
                      getGeneral(quality_inspect, quality_attribute)?.min_value
                    }}
                  </p>
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- average -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- min_value -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- max_value -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-for="group_range in group_ranges"
                  :key="group_range.id"
                ></td>
              </tr>
              <tr class="table-row divide-x">
                <td class="table-cell-pos px-1 text-center">
                  {{ $t("model.quality_general.max_value") }}
                </td>
                <td
                  v-for="quality_attribute in quality_attributes"
                  :key="quality_attribute.id"
                  class="table-cell-main text-center"
                >
                  <p
                    v-if="
                      showStatsAttribute(quality_attribute) &&
                      quality_samplings?.length > 1
                    "
                  >
                    {{
                      getGeneral(quality_inspect, quality_attribute)?.max_value
                    }}
                  </p>
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- average -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- min_value -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-if="show_group_stats"
                >
                  <!-- max_value -->
                </td>
                <td
                  class="table-cell-main text-center px-1.5"
                  v-for="group_range in group_ranges"
                  :key="group_range.id"
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsMixin from "@/components/views/mixins/agro_exporter/quality_control/container/show_inspect/quality_group_details.js";
import ShowSamplingValue from "@/components/views/layout/quality_control/ShowSamplingValue.vue";

export default {
  mixins: [DetailsMixin],
  components: { ShowSamplingValue },
};
</script>

<style>
</style>
